import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL || `http://${window.location.hostname}:8001`;

const api = axios.create({
    baseURL: API_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        console.log('DEBUG: Attaching token:', token.substring(0, 10) + '...');
    } else {
        console.warn('DEBUG: No token found in localStorage');
    }
    return config;
});

// Handle response errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;